import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories } from '@/mocks/categories';

export default function CategoryPlaceholder() {
  const { type } = useParams<{ type: string }>();
  const category = categories.find((c) => c.key === type);

  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-16 flex flex-col items-center justify-center px-4">
        <h1 className="font-heading text-3xl text-foreground-900 mb-4">
          {category?.label || '分类'} 页面
        </h1>
        <p className="text-foreground-500 mb-8">此页面将在第二阶段开发中完成，敬请期待！</p>
        <Link to="/" className="px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
          返回首页
        </Link>
      </main>
      <Footer />
    </>
  );
}